import "./App.css";
import { ApolloProvider, ApolloClient, InMemoryCache } from "@apollo/client";
import { BrowserRouter, Switch, Route, useHistory } from "react-router-dom";
import { SecureRoute, Security, LoginCallback } from "@okta/okta-react";
import { toRelativeUrl } from "@okta/okta-auth-js";
import { Provider } from "./Context";
import Nav from "./Nav.jsx";
import Home from "./components/Home";
import ManageFeatureFlags from "./components/ManageFeatureFlags";
import ProvisionStatus from "./components/ProvisionStatus.jsx";
import UpdateMacPin from "./components/UpdateMacPin.jsx";
import LoginPage from "./components/LoginPage.jsx";
import Header from "./components/Header.jsx";
import ProvisionDevice from "./components/ProvisionDevice.jsx";
import { oktaAuth } from "./const/okta.js";

const client = new ApolloClient({
  uri: process.env.REACT_APP_DATA_SERVICE_ENDPOINT,
  cache: new InMemoryCache(),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: "no-cache",
      errorPolicy: "ignore",
    },
    query: {
      fetchPolicy: "no-cache",
      errorPolicy: "all",
    },
  },
});


function App() {
  const history = useHistory();
  const restoreOriginalUri = async (_oktaAuth, originalUri) => {
    history.replace(toRelativeUrl(originalUri || "/", window.location.origin));
  };

  return (
    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
      <ApolloProvider client={client}>
        <Provider>
          <Switch>
            <Route
              path="/login/callback"
              render={() => (
                <LoginCallback loadingElement={<LoginPage disabledOnLoad={true}/>} />
              )}
            />
            <Route exact path="/">
              <LoginPage />
            </Route>
            <Route>
              <Nav>
                <Header>
                  <Route exact path="/home" component={Home} />
                  <Route
                    exact
                    path="/update-mac-pin"
                    component={UpdateMacPin}
                  />
                  <Route
                    exact
                    path="/provision-device"
                    component={ProvisionDevice}
                  />

                  <SecureRoute exact path="/manage-feature-flags">
                    <ManageFeatureFlags />
                  </SecureRoute>

                  <SecureRoute exact path="/provision-status">
                    <ProvisionStatus />
                  </SecureRoute>
                </Header>
              </Nav>
            </Route>
          </Switch>
        </Provider>
      </ApolloProvider>
    </Security>
  );
}

function RouterApp() {
  return (
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
}

export default RouterApp;
